import { render, staticRenderFns } from "./newPrip.vue?vue&type=template&id=6f0e6e19&scoped=true"
import script from "./newPrip.vue?vue&type=script&lang=js"
export * from "./newPrip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0e6e19",
  null
  
)

export default component.exports